import { render, staticRenderFns } from "./RecognisedPart.vue?vue&type=template&id=53c1c176&scoped=true"
import script from "./RecognisedPart.vue?vue&type=script&lang=js"
export * from "./RecognisedPart.vue?vue&type=script&lang=js"
import style0 from "./RecognisedPart.vue?vue&type=style&index=0&id=53c1c176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c1c176",
  null
  
)

export default component.exports